import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./BackButton.scss";
import { IconButton } from "../input/IconButton";
import { ReactComponent as ArrowBackIcon } from "../icons/ArrowBack.svg";

export function BackButton({ className, ...rest }) {
  return (
    <IconButton className={classNames(styles.backButton, className)} {...rest}>
      <ArrowBackIcon />
    </IconButton>
  );
}

BackButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
